import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { State } from "@features/base/types";
import {
  AdminCache,
  AdminCachesResponse,
  changeAdminCacheApi,
  createAdminCacheApi,
  CreateCacheRequest,
  getAdminCachesApi,
} from "./api";

export const getAdminCaches = createAsyncThunk<
  AdminCachesResponse,
  { userId: string }
>("adminBalances/getAdminCaches", async ({ userId }, { rejectWithValue }) => {
  try {
    return await getAdminCachesApi(userId);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createAdminCache = createAsyncThunk<
  string,
  { userId: string; data?: CreateCacheRequest }
>(
  "adminBalances/createAdminCache",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      return await createAdminCacheApi(userId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeAdminCache = createAsyncThunk<string, { cacheId: string }>(
  "adminBalances/changeAdminCache",
  async ({ cacheId }, { rejectWithValue }) => {
    try {
      return await changeAdminCacheApi(cacheId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type AdminBalancesState = State<{
  caches: AdminCache[] | null;
  loading: boolean;
  error: string | null;
  selectedCacheId: string | null;
}>;

const initialState: AdminBalancesState = {
  caches: null,
  loading: false,
  error: null,
  selectedCacheId: null,
};

const adminCachesSlice = createSlice({
  name: "adminBalances",
  initialState,
  reducers: {
    setSetSelectedCache: (state, action: PayloadAction<string>) => {
      state.selectedCacheId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminCaches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminCaches.fulfilled, (state, action) => {
        state.loading = false;
        state.caches = action.payload;
      })
      .addCase(getAdminCaches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(createAdminCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAdminCache.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
      })
      .addCase(createAdminCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(changeAdminCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeAdminCache.fulfilled, (state, action) => {
        state.loading = false;
        // const selectedCache = state.caches?.find(
        //   (cache) => cache.id == state.selectedCacheId
        // );
        // if (selectedCache != null) selectedCache.api_key = action.payload;
        console.log(action.payload);
      })
      .addCase(changeAdminCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSetSelectedCache } = adminCachesSlice.actions;
export default adminCachesSlice.reducer;
